import theme from "@/styles/theme";
import styled from "styled-components";

export const Container = styled.div``;

export const SaleContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 1vw;
  border: solid 1px ${theme.colors.brown.capivaraLight};
  color: white;
  justify-content: center;
  padding: 10px;
  width: 95%;
  align-self: center;
  margin-bottom: 2vh;
  border-radius: 5px;
  text-align: justify;
`;
export const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  //flex: 8;
  column-gap: 1vw;
  width: 95%;
  align-self: center;
  @media (${theme.devices.tablet}) {
    flex-direction: column;
  }
`;
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  border: 1px solid ${theme.colors.palete.brownLight};
  border-radius: 5px;
  background: linear-gradient(to top right, #a9884d 80%, #c8a05e 50%);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: box-shadow 0.3s ease;
  flex: 1;
  font-family: sans-serif;
  height: 78px;
  justify-content: center;
  .left {
    margin-bottom: 1vh;
    font-size: ${theme.fontSize.mm};
  }
  .right {
    font-weight: 800;
    margin-left: auto;
    font-size: ${theme.fontSize.md};
  }
  .icons {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: black;
    font-size: ${theme.fontSize.md};
    align-self: center;
    column-gap: 0.5vw;
    font-weight: 800;
    font-size: ${theme.fontSize.md};
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  width: 95%;
  margin-top: 3vh;
  align-self: center;
`;

export const DgContainer = styled.div`
  display: flex;
  width: 95%;
  margin-top: 3vh;
  align-self: center;
  justify-content: center;
`;
